import { BaseProvider } from "./base.provider";
import { injectScript } from "../utilities/dom-mutations";
import { jsonParser } from "../utilities/parsers";
export class TwainsportsProvider extends BaseProvider {
    initGame(scriptData) {
        window.TwainSports.setup({
            containerElement: document.getElementById("lobby_game"),
            clientUrl: scriptData.clientUrl,
            apiUrl: scriptData.apiUrl,
            wsUrl: scriptData.wsUrl,
            partnerCode: scriptData.partnerCode,
            token: scriptData.playerToken,
            timezone: scriptData.timeZone,
            locale: scriptData.language,
            gameId: scriptData.gameId,
            dynamicHeight: 1,
            showBalance: !!scriptData.showBalance === true ? 1 : 0, // We should use 1 and 0, instead of true and false, respectively.
            // oddsFormat: '<ODD_FORMAT>',
            // showLogo: false,
            // theme: '<THEME>'
        });
    }
    init() {
        const { clientScriptData } = this.launchData;
        const scriptData = jsonParser(clientScriptData);
        const scripts = [
            {
                url: `${scriptData.clientUrl}/public/ts-loader.js?${Date.now()}`,
            },
        ];
        const mappedScripts = scripts.map((s, index) => {
            return {
                hid: `twainexternalscript-${index}`,
                src: s.url,
                callback: () => this.initGame(scriptData),
            };
        });
        injectScript(mappedScripts);
    }
}
